import { Component, inject, input, LOCALE_ID, signal, HostListener } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RoleVTO } from '../../../../../services/role/role-service.model';
import { UserDetailsVTO } from '../../../../../services/auth-service.model';

@Component({
  selector: 'app-user-info-tab',
  imports: [CommonModule, DatePipe],
  templateUrl: './user-info-tab.html',
  styleUrl: './user-info-tab.scss',
  standalone: true,
})
export class UserInfoTab {
  private locale = inject(LOCALE_ID);

  data = input.required<UserDetailsVTO>();
  showDropdown = signal(false);

  @HostListener('document:click')
  onDocumentClick() {
    this.showDropdown.set(false);
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.showDropdown.update(v => !v);
  }

  get fullName(): string {
    return `${this.data().firstName} ${this.data().lastName}`.trim();
  }

  get genderLabel(): string | null {
    const gender = this.data().gender;
    if (!gender) return null;
    const isAr = this.isArabic();
    return gender === 'F'
      ? isAr ? 'أنثى' : 'Female'
      : isAr ? 'ذكر' : 'Male';
  }

  get languageLabel(): string {
    const isAr = this.isArabic();
    return this.data().defaultLanguage === 'AR'
      ? isAr ? 'العربية' : 'Arabic'
      : isAr ? 'الإنجليزية' : 'English';
  }

  get notAssigned(): string {
    return this.isArabic() ? "—"  : "—" ;
  }

  get formattedMobile(): string {
    const num = this.data().mobileNumber;
    if (!num) return '';
    if (this.isArabic() && num.startsWith('+')) {
      return num.slice(1) + '+';
    }
    return num;
  }

  getRoleColor(index: number): string {
    const colors = [
      'bg-blue-50 text-blue-700 border-blue-100',
      'bg-purple-50 text-purple-700 border-purple-100',
      'bg-green-50 text-green-700 border-green-100',
      'bg-yellow-50 text-yellow-700 border-yellow-100',
      'bg-pink-50 text-pink-700 border-pink-100',
    ];
    return colors[index % colors.length];
  }

  getRoleTitle(role: RoleVTO): string {
    return this.isArabic() ? role.titleAr : role.titleEn;
  }

  isArabic(): boolean {
    return this.locale.startsWith('ar');
  }
}